/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * active_total object
 * @export
 * @interface GetFwLeaderboardsCorporationsActiveTotalActiveTotal1
 */
export interface GetFwLeaderboardsCorporationsActiveTotalActiveTotal1 {
    /**
     * Amount of victory points
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsActiveTotalActiveTotal1
     */
    amount?: number;
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsActiveTotalActiveTotal1
     */
    corporationId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCorporationsActiveTotalActiveTotal1 interface.
 */
export function instanceOfGetFwLeaderboardsCorporationsActiveTotalActiveTotal1(value: object): value is GetFwLeaderboardsCorporationsActiveTotalActiveTotal1 {
    return true;
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotal1FromJSON(json: any): GetFwLeaderboardsCorporationsActiveTotalActiveTotal1 {
    return GetFwLeaderboardsCorporationsActiveTotalActiveTotal1FromJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotal1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCorporationsActiveTotalActiveTotal1 {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'corporationId': json['corporation_id'] == null ? undefined : json['corporation_id'],
    };
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotal1ToJSON(json: any): GetFwLeaderboardsCorporationsActiveTotalActiveTotal1 {
    return GetFwLeaderboardsCorporationsActiveTotalActiveTotal1ToJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsActiveTotalActiveTotal1ToJSONTyped(value?: GetFwLeaderboardsCorporationsActiveTotalActiveTotal1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'corporation_id': value['corporationId'],
    };
}

